export enum KanbanColumnStageType {
  CLOSED_WON = "CLOSED-WON",
  CLOSED_LOST = "CLOSED-LOST",
  CLOSED_TO_COMPETITION = "CLOSED-TO-COMPETITION",
}
